// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.legend[data-v-39359104] {\n    display: inline-block;\n    height: 10px;\n    width: 10px;\n}\n.legendTxt[data-v-39359104]{\n    position: relative;\n    top: -8px;\n    font-size: 0.75rem;\n}\n.BlurClass[data-v-39359104]{\n    opacity: 0.8;\n}\n.darkTheme .modal-content[data-v-39359104] {\n    color: #dddddd !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
